import { render, staticRenderFns } from "./GalleryNewModal.vue?vue&type=template&id=bf445b78&scoped=true&"
import script from "./GalleryNewModal.vue?vue&type=script&lang=js&"
export * from "./GalleryNewModal.vue?vue&type=script&lang=js&"
import style0 from "./GalleryNewModal.vue?vue&type=style&index=0&id=bf445b78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf445b78",
  null
  
)

export default component.exports